import React from 'react';
import { Label } from '../../../ui/label';

/**
 * Consistent label + hint + control stack for employee survey inputs.
 *
 * Keeps the mobile layout tight (less margin than the admin FormGroup)
 * so the viewport can hold 2-3 questions per screen.
 */
const FieldStack = ({ label, hint, children, required = false }) => (
  <div>
    <Label className='text-sm font-medium mb-1.5 block'>
      {label}
      {required && <span className='text-destructive ml-0.5'>*</span>}
    </Label>
    {children}
    {hint && <div className='text-[11px] text-muted-foreground mt-1.5'>{hint}</div>}
  </div>
);

export const ChoiceCard = ({ active, icon: Icon, label, desc, onClick }) => (
  <button
    type='button'
    onClick={onClick}
    className={`w-full text-left rounded-xl border-2 p-3.5 transition-all flex items-start gap-3 ${
      active ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/40'
    }`}>
    {Icon && (
      <div
        className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
          active ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
        }`}>
        <Icon size={16} strokeWidth={1.5} />
      </div>
    )}
    <div className='flex-1'>
      <div className='text-sm font-semibold'>{label}</div>
      {desc && <div className='text-[11px] text-muted-foreground mt-0.5'>{desc}</div>}
    </div>
    <div
      className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-0.5 ${
        active ? 'border-primary bg-primary' : 'border-input'
      }`}>
      {active && <span className='w-2 h-2 rounded-full bg-primary-foreground' />}
    </div>
  </button>
);

export default FieldStack;
